export default "__VITE_ASSET__D0idntM9__"